import angular from 'angular';

import { withControlledInput } from '@/react-tools/withControlledInput';
import { withCurrentUser } from '@/react-tools/withCurrentUser';
import { withReactQuery } from '@/react-tools/withReactQuery';
import { withUIRouter } from '@/react-tools/withUIRouter';
import { withFormValidation } from '@/react-tools/withFormValidation';
import { r2a } from '@/react-tools/react2angular';
import { MacvlanNodesSelector } from '@/react/docker/networks/CreateView/MacvlanNodesSelector/MacvlanNodesSelector';
import { MacvlanFormSection } from '@/react/docker/networks/CreateView/MacvlanFormSection/MacvlanFormSection';
import { macvlanFormValidation } from '@/react/docker/networks/CreateView/MacvlanFormSection/validation';

const ngModule = angular.module(
  'portainer.docker.react.components.networks',
  []
);

ngModule.component(
  'macvlanNodesSelector',
  r2a(withUIRouter(MacvlanNodesSelector), [
    'dataset',
    'isIpColumnVisible',
    'haveAccessToNode',
    'value',
    'onChange',
  ])
);

withFormValidation(
  ngModule,
  withUIRouter(
    withReactQuery(
      withCurrentUser(
        withControlledInput(MacvlanFormSection, { values: 'onChange' })
      )
    )
  ),
  'networkMacvlanForm',
  ['environmentId', 'isAgentProxy', 'isSwarmMode', 'apiVersion'],
  macvlanFormValidation
);

export const networksModule = ngModule.name;
